import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withPlaceholderStyle from './index';

const PlaceholderThumb = ({ style, ...props }) => {
  const { placeholder } = props;

  return (
    <div
      style={style}
      className={classNames({
        'editor-placeholder': true,
        'editor-placeholder-thumb': true,
        [placeholder.type]: placeholder.type,
      })}
    />
  );
};

PlaceholderThumb.propTypes = {
  style: PropTypes.object.isRequired,
  placeholder: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
};

export default withPlaceholderStyle(PlaceholderThumb);
